import React from 'react'
import { FormattedMessage } from 'react-intl'
import { twMerge } from 'tailwind-merge'
import MouseGradientBlock from '../../../components/MouseGradientBlock'

interface PartnerWithUsBlockProps {
  id: string
  Icon: JSX.Element
}

const PartnerWithUsBlock = ({ id, Icon }: PartnerWithUsBlockProps) => {
    return (
        <MouseGradientBlock className='aspect-auto border-b border-black/10'>
            <div className={twMerge('py-6 md:p-[60px] transition-all')}>
                <div className=' md:max-w-[460px]'>
                    <div className='flex flex-row md:flex-col items-center md:items-start pb-6 md:pb-0 gap-x-4 md:gap-x-0'>
                        <Icon.type className='w-12 h-12 md:h-28 md:w-28' />
                        <div className='md:pb-6 md:pt-20'>
                            <FormattedMessage id={`page.partnerships.partnerWithUs.${id}`} tagName='h4' />
                        </div>
                    </div>

                    <FormattedMessage id={`page.partnerships.partnerWithUs.${id}.description`}>
                        {(value) => <p className='text-[14px] tracking-normal'>{value}</p>}
                    </FormattedMessage>
                </div>
            </div>
        </MouseGradientBlock>
    )
}

export default PartnerWithUsBlock
